import styled from 'vue-styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, .5fr);
  grid-template-rows: repeat(2, .4fr);
  gap: 3rem;
  width: 100%;
  margin-top: 2rem;
`;
